import { UserState } from "./types";

const initialState = (): UserState => ({
  aliases: [],
  course: {
    history: {}
  },
  groupNames: [],
  groups: undefined,
  orgName: "",
  userName: "",
  authentication: {
    error: "",
    jwtValidationError: "",
    tmpPasswordValidated: false,
    token: undefined
  },
  profile: undefined,
  pwdReset: {
    error: ""
  },
  selectedAlias: undefined
});

const userState = initialState();

export { userState };
